import React from 'react';
import cn from 'classnames';

import { CheckBox, GameLogo, Icon } from 'components';
import { Action, Category } from 'services/analytics';

import live from 'assets/svg/live.svg';
import './CategorizerRowHeader.scss';

interface Props {
    hasBorder?: boolean;
    label: string;
    gameId?: string;
    countryCode?: string | null;
    isOpened: boolean;
    isSelected: boolean;
    additionalIcon?: JSX.Element | null | boolean;
    onClick: (e: React.SyntheticEvent) => void;
    onSelect: VoidFunction;
    isLive?: boolean;
}

const SELECT_SPORT_ANALYTICS = {
    category: Category.FiltersCategorizer,
    action: Action.SelectSport,
};

const CategorizerRowHeader: React.FC<Props> = ({
    hasBorder = true,
    countryCode,
    label,
    children,
    additionalIcon,
    gameId,
    isSelected,
    isOpened,
    onSelect,
    onClick,
    isLive,
}) => {
    const handleCheckboxChange = (e: React.SyntheticEvent) => {
        e.stopPropagation();

        if (!onSelect) return;

        onSelect();
    };

    return (
        <div
            styleName={cn('header', {
                'is-opened': isOpened,
                'is-selected': isSelected,
                'has-border': hasBorder,
            })}
            className="__app-CategorizerRowHeader-container"
            onClick={onClick}
            data-category={Category.FiltersCategorizer}
            data-action={Action.OpenSport}
        >
            {!countryCode && gameId && (
                <div styleName="icon">
                    <div styleName="logo">
                        <GameLogo gameId={gameId} />
                    </div>
                </div>
            )}

            <CheckBox
                checked={isSelected}
                onChange={handleCheckboxChange}
                analytics={SELECT_SPORT_ANALYTICS}
            />

            {additionalIcon && (
                <div className="__app-CategorizerRowHeader-additional-icon">
                    {additionalIcon}
                </div>
            )}

            <div
                styleName="label"
                title={label}
                className="__app-CategorizerRowHeader-label"
            >
                {children || label}
            </div>
            {isLive && <Icon glyph={live} styleName="live" />}

            {isOpened && <div styleName="divider" />}
        </div>
    );
};

export default CategorizerRowHeader;
